var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
// Material ui Imports
import { Box, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
// Customer components imports (and hooks and helpers)
import VTButton from "./VTButton";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTMenu use for web development to replace the material ui menu
export default forwardRef(function (_a, ref) {
    var startIcon = _a.startIcon, endIcon = _a.endIcon, disabled = _a.disabled, type = _a.type, children = _a.children, disableElevation = _a.disableElevation, color = _a.color, sx = _a.sx, menuOptions = _a.menuOptions, width = _a.width, _b = _a.direction, direction = _b === void 0 ? "DOWN" : _b, _c = _a.offsetWidth, offsetWidth = _c === void 0 ? 120 : _c, _d = _a.offsetHeight, offsetHeight = _d === void 0 ? 270 : _d, onCloseFunction = _a.onCloseFunction, closeMenu = _a.closeMenu, menuOpen = _a.menuOpen, setMenuOpen = _a.setMenuOpen, onClick = _a.onClick, toolTipOptions = _a.toolTipOptions, _e = _a.popOutMenuZIndex, popOutMenuZIndex = _e === void 0 ? 3 : _e;
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    var _f = __read(useState(null), 2), anchorMenu = _f[0], setAnchorMenu = _f[1];
    //-------------------------------------------------------------------------------------------------
    // ## Function ##
    function closeFunction() {
        setAnchorMenu(null);
        if (onCloseFunction) {
            onCloseFunction();
        }
    }
    useImperativeHandle(ref, function () { return ({
        closePopUpMenu: closeFunction,
    }); }, []);
    useEffect(function () {
        if (closeMenu) {
            closeFunction();
        }
    }, [closeMenu]);
    useEffect(function () {
        if (menuOpen !== undefined && menuOpen === false && anchorMenu !== null) {
            setAnchorMenu(null);
        }
    }, [menuOpen]);
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    return (_jsx(Tooltip, __assign({ open: toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.alwaysOpen, 
        // open={true}
        // disableHoverListener={!Boolean(toolTipOptions?.toolTipText)}
        placement: toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.toolTipPlacement, arrow: Boolean(toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.arrow), title: toolTipOptions === null || toolTipOptions === void 0 ? void 0 : toolTipOptions.toolTipText }, { children: _jsxs(Box, __assign({ component: "div", onClick: function (e) {
                e.stopPropagation();
            }, sx: __assign({ display: "inline-block" }, sx) }, { children: [_jsx(VTButton, __assign({ startIcon: startIcon, endIcon: endIcon, disabled: disabled, type: type, disableElevation: disableElevation, color: color, sx: { width: "100%", height: "100%" }, onClick: function (e) {
                        e.stopPropagation();
                        setAnchorMenu(e.currentTarget);
                        onClick && onClick();
                    } }, { children: children })), menuOptions && (_jsx(Menu, __assign({ onMouseDown: function (e) {
                        e.stopPropagation();
                    }, onMouseUp: function (e) {
                        e.stopPropagation();
                    }, onClick: function (e) {
                        e.stopPropagation();
                    }, anchorEl: anchorMenu, open: Boolean(anchorMenu), onClose: function () {
                        closeFunction();
                    }, sx: __assign({ zIndex: popOutMenuZIndex }, (direction === "UP"
                        ? {
                            position: "absolute",
                            top: "-".concat(offsetHeight, "px"),
                            left: "-".concat(offsetWidth, "px"),
                        }
                        : { marginTop: "5px" })) }, { children: menuOptions.map(function (element) {
                        return element.component ? (element.component) : (_jsx(MenuItem, __assign({ onClick: element.onClick, sx: { width: width && width }, 
                            // @ts-ignore
                            to: element.to, 
                            // @ts-ignore
                            component: element.to ? Link : "button" }, { children: _jsx(Typography, __assign({ sx: { width: "100%" }, align: "center" }, { children: element.title })) })));
                    }) })))] })) })));
});
